export default __webpack_public_path__ + "static/media/akun_red.6ffb7a22.svg";